import {
  TreePine, Flame, ShoppingCart, ArrowLeftRight, PackagePlus, Boxes, History, Tags,
  PlusCircle, MinusCircle, Users, BellRing, Landmark, HandCoins, Upload, BookOpen,
  FileCheck2, Receipt, Gem, Calculator,
} from "lucide-react";
import { canSee, canSeeAny } from "@/lib/menus";

const it = (show, label, sub, to, icon, add = false) => (show ? { label, sub, to, icon, add } : null);
const sec = (title, items) => ({ title, items: items.filter(Boolean) });

export function buildQuickAccess(user, { jenis, isGab, targetsBriket }) {
  const c = (k) => canSee(user, k);
  const ws = user?.workspace_type || "hostnesia";
  const isAdmin = user?.role === "admin";
  let sections;
  if (ws === "pribadi") {
    sections = [
      sec("Pemasukan", [
        it(c("pemasukan"), "Tambah Pemasukan", "Catat uang masuk", "/pemasukan?new=1", PlusCircle, true),
        it(c("kategori_pemasukan"), "Input Kategori", "Kategori pemasukan", "/pemasukan/kategori?new=1", Tags),
      ]),
      sec("Pengeluaran", [
        it(c("pengeluaran"), "Tambah Pengeluaran", "Catat uang keluar", "/pengeluaran?new=1", MinusCircle, true),
        it(c("kategori_pengeluaran"), "Input Kategori", "Kategori pengeluaran", "/pengeluaran/kategori?new=1", Tags),
      ]),
      sec("Kas & Bank", [
        it(c("akun"), "Tambah Akun / Dompet", "Rekening & e-wallet", "/pribadi/akun?new=1", Landmark, true),
        it(c("transfer"), "Transfer Antar Akun", "Pindah saldo", "/pribadi/transfer?new=1", ArrowLeftRight, true),
        it(c("impor_mutasi"), "Impor Mutasi Bank", "Unggah CSV", "/pribadi/impor-mutasi", Upload),
      ]),
      sec("Pajak Pribadi", [
        it(canSeeAny(user, ["spt_coretax", "pph_op"]), "Panduan Bayar Pajak", "Langkah demi langkah", "/pribadi/panduan-pajak", BookOpen),
        it(canSeeAny(user, ["spt_coretax", "pph_op"]), "Asisten SPT Coretax", "Isian SPT tahunan", "/pribadi/spt-coretax", FileCheck2),
        it(c("kredit_pajak"), "Bukti Potong", "Kredit pajak", "/pribadi/kredit-pajak", Receipt),
        it(c("riwayat_bayar"), "Riwayat Bayar Pajak", "Setoran pajak", "/pajak/riwayat-bayar", Calculator),
        it(c("harta"), "Daftar Harta", "L-1 A", "/pribadi/harta", Gem),
      ]),
    ];
  } else {
    const arang = ws === "arang";
    sections = [
      sec("Produksi", arang ? [
        it(jenis === "tungku" && c("produksi_kayu"), "Kayu Masuk", "Catat kayu masuk", "/produksi/kayu?new=1", TreePine, true),
        it(jenis === "tungku" && c("produksi_bakar"), "Batch Bakar", "Mulai bakar", "/produksi/bakar?new=1", Flame, true),
        it(jenis === "reseller" && c("produksi_pembelian"), "Pembelian Arang", "Catat pembelian", "/produksi/pembelian?new=1", ShoppingCart, true),
        it((jenis === "tungku" || jenis === "reseller") && targetsBriket?.length > 0 && c("produksi_transfer"), "Transfer Stok", "Kirim ke pabrik briket", "/produksi/transfer?new=1", ArrowLeftRight, true),
        it(jenis === "briket" && c("produksi_bahan"), "Bahan Masuk", "Catat bahan briket", "/produksi/bahan?new=1", PackagePlus, true),
        it(jenis === "briket" && c("produksi_briket"), "Produksi Briket", "Cetak briket", "/produksi/briket?new=1", Boxes, true),
        it(c("produksi"), "Riwayat Stok Masuk", "Lihat riwayat", "/produksi", History),
        it(isAdmin && !isGab && c("kategori_produk"), "Kategori Produk", "Tambah kategori", "/produksi/kategori?new=1", Tags),
      ] : []),
      sec("Pemasukan", [
        it(c("pemasukan"), "Tambah Pemasukan", "Buat invoice baru", "/pemasukan?new=1", PlusCircle, true),
        it(c("kategori_pemasukan"), "Input Kategori", "Kategori pemasukan", "/pemasukan/kategori?new=1", Tags),
        it(c("pembeli"), "Master Data Pembeli", "Tambah pembeli", "/pemasukan/pembeli?new=1", Users),
        it(arang && c("piutang"), "Piutang Reminder", "Tagihan belum lunas", "/piutang", BellRing),
      ]),
      sec("Pengeluaran", [
        it(c("pengeluaran"), "Tambah Pengeluaran", "Catat biaya", "/pengeluaran?new=1", MinusCircle, true),
        it(c("kategori_pengeluaran"), "Input Kategori", "Kategori pengeluaran", "/pengeluaran/kategori?new=1", Tags),
      ]),
      sec("Kas & Bank", [
        it(c("akun"), "Tambah Akun", "Kas & rekening bank", "/kas-bank/akun?new=1", Landmark, true),
        it(c("transfer"), "Transfer Antar Akun", "Pindah saldo", "/kas-bank/transfer?new=1", ArrowLeftRight, true),
      ]),
      sec("Utang & Piutang", [
        it(c("hutang_piutang"), "Tambah Utang / Piutang", "Catat pinjaman", "/hutang-piutang?new=1", HandCoins, true),
      ]),
    ];
  }
  return sections.filter((s) => s.items.length > 0);
}
